import React from 'react';
import Modal from './Modal';
import PropTypes from 'prop-types';

const SimpleModal = props => {
  const { visible, title, children, onCancel, wrapClassName } = props;
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      title={title}
      wrapClassName={wrapClassName}
      getContainer={false}
    >
      {children}
    </Modal>
  );
};

SimpleModal.props = {
  visible: PropTypes.bool,
  title: PropTypes.string,
  onCancel: PropTypes.func,
  wrapClassName: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

export default SimpleModal;
